import type { SlideImage } from "yet-another-react-lightbox";
import { ILoginResponse } from "../Framework/Login/Login";
import { ELoadingStatus } from "./Enums";

export enum View {
  "INITIAL",
  "ABOUT",
  "BAR",
  "FOOD",
  "DRINK",
  "MUSIC",
  "KARAOKE",
  "GALLERY",
  "VIDEO",
  "PICTURE",
  "PROPS",
  "MAST",
  "CANNON",
  "RIGGING",
  "CROW",
  "WHEEL",
  "CORNER",
  "SHIP",
  "FAQ",  
  "CONTACT",
  "MERCH",
  "ATTENDEES",
  "REGISTER",
  "RSVP",
  "LOGOUT",  
}

export interface IEncryptedPayload {
  data: string;
  nonce: string;
  tag: string;
}

export interface IUP {
  user: string;
  pswd: string;
}


export interface IAuth {
  token: string;
}

export interface ISaturdayCount {
  _id: string;
  count: number;
}


export interface ISaturdayVote{
  saturdays: string[];
  email: string;
  mode: string;
  token: string;
}


export interface IRsvpProps {
  handleSubmit: (total: number) => void;
  handleExit: () => void;
}

export interface IMerchProps {
  handleMerchRequest: () => void;
  handleClose:  () => void;
  token: string;
}
  
export interface IDialogManager {
  classx? : any;
  title: string;
  message: string; 
  button1: string; 
  button2?: string;
  button3?: string;
  exceptionType?: string;
  viewType?: string;
  data? : any;
}

export interface IAttendee{
  count: number;
  group: string;
  email: string;
  token: string;
}

export interface IImage {
    original: string;
    thumbnail: string;
}

export interface IAttendeeResponse {
    attendee: string;
    response: string;
}


export interface IAttendeeResponse {
    attendee: string;
    response: string;
}

export interface IValidationResponse {
  response: string;
  validation: string;
}

export interface IMerchandise {
    email: string; 
    small: number;
    medium: number;
    large: number;
    xlarge: number;
    token: string;
}

export interface IMerchandiseResponse {
  response: string,
}

export interface ICredentials {
  passWord: string,
  userName: string,    
  groupName: string,    
  token: string;
}


export interface IPromptGDPRProps {
  handleShow: () => void;
  handleAllow: () => void;
}

export interface IGDPR {
  open_modal: boolean,
  callback_close: (event: any) => void;
}

// Define a type for the slice state
export interface IJamHawState {
  
  validate_loading: ELoadingStatus;
  attendees_loading: ELoadingStatus;
  attendees_response_loading: ELoadingStatus;
  merchandise_loading: ELoadingStatus;
  merchandise_response_loading: ELoadingStatus;
  saturday_vote_loading: ELoadingStatus;
  auth_loading: ELoadingStatus;

  error_validate_msg: string;
  error_attendees_msg: string;
  error_attendees_response_msg: string;
  error_merchandise_msg: string;
  error_merchandise_response_msg: string;
  
  isOK: boolean;
  isCANCEL: boolean;
  dialogMessage: IDialogManager;
  showDialog: boolean; 
  view: string;
  loggedIn: boolean;
  gdpr: boolean;
  galleryMode: boolean;
  showMenu: boolean;
  showSidebar: boolean;
  showFooter: boolean;
  credentials: ICredentials; 
  
  auth: IAuth;
  saturdays : ISaturdayVote;
  attendees: IAttendee[];
  attendees_response: IAttendeeResponse | undefined;

  merchandise: IMerchandise[];
  merchandise_response: IMerchandiseResponse | undefined;

  validate: IValidationResponse;
  gallery: IImage[];
  passwordFail: boolean ;
  emailFail: boolean ;
}

export declare interface IMainProps {
  token: string;
  confirmation: string;
  credentials: ICredentials,
  slides: SlideImage[],
  //saturdays: ISaturdayVote,
  //HandleSaturdays: (event:ISaturdayVote) => void;
  voted: boolean;
  toggle: boolean;
}
export declare interface IPictureProps {
  slides: SlideImage[],
}